import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createTreatmentSlice = createAsyncThunk(
    "treatment/createTreatment",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/treatment/createTreatment", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getTreatmentSlice = createAsyncThunk(
    "treatment/getTreatment",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/treatment/getTreatment", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);


export const updateTreatmentSlice = createAsyncThunk(
    "treatment/updateTreatment",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put("/treatment/updateTreatment", data, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);


export const deleteTreatmentSlice = createAsyncThunk(
    "treatment/deleteTreatment",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put("/treatment/deleteTreatment", data, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

const initialState = {
    loading: false,
    treatments: [],
    createTreatmentSuccessMessage: null,
    createTreatmentErrorMessage: null,
    updateTreatmentSuccessMessage: null,
    updateTreatmentErrorMessage: null,
    deleteTreatmentSuccessMessage: null,
    deleteTreatmentErrorMessage: null,
    searchTreatmentErrorMessage: null,
};

const treatmentSlice = createSlice({
    name: "treatment",
    initialState,
    reducers: {
        resetCreateTreatmentMessage: (state) => {
            state.createTreatmentSuccessMessage = null;
            state.createTreatmentErrorMessage = null;
        },
        resetUpdateTreatmentMessage: (state) => {
            state.updateTreatmentSuccessMessage = null;
            state.updateTreatmentErrorMessage = null;
        },
        resetDeleteTreatmentMessage: (state) => {
            state.deleteTreatmentSuccessMessage = null;
            state.deleteTreatmentErrorMessage = null;
        },
        resetSearchTreatmentMessage: (state) => {
            state.searchTreatmentErrorMessage = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createTreatmentSlice.pending, (state) => {
                state.loading = true;
                state.createTreatmentSuccessMessage = null;
                state.createTreatmentErrorMessage = null;
            })
            .addCase(createTreatmentSlice.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.createTreatmentErrorMessage = action.payload.result.message;
                } else {
                    state.createTreatmentSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(createTreatmentSlice.rejected, (state, action) => {
                state.loading = false;
                state.createTreatmentErrorMessage = action.payload.result.message;
            })
            .addCase(getTreatmentSlice.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getTreatmentSlice.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.searchTreatmentErrorMessage = action.payload.result.message;
                }
                state.treatments = action.payload.result.list
            })
            .addCase(getTreatmentSlice.rejected, (state, action) => {
                state.loading = false;
                state.searchTreatmentErrorMessage = action.payload.result?.message;
            })
            .addCase(updateTreatmentSlice.pending, (state) => {
                state.loading = true;
                state.updateTreatmentSuccessMessage = null;
                state.updateTreatmentErrorMessage = null;
            })
            .addCase(updateTreatmentSlice.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.updateTreatmentErrorMessage = action.payload.result.message;
                } else {
                    state.updateTreatmentSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(updateTreatmentSlice.rejected, (state, action) => {
                state.loading = false;
                state.updateTreatmentErrorMessage = action.payload.result.message;
            })
            .addCase(deleteTreatmentSlice.pending, (state) => {
                state.loading = true;
                state.deleteTreatmentSuccessMessage = null;
                state.deleteTreatmentErrorMessage = null;
            })
            .addCase(deleteTreatmentSlice.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.deleteTreatmentErrorMessage = action.payload.result.message;
                } else {
                    state.deleteTreatmentSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(deleteTreatmentSlice.rejected, (state, action) => {
                state.loading = false;
                state.deleteTreatmentErrorMessage = action.payload.result.message;
            })
    },
});

export const { resetCreateTreatmentMessage, resetUpdateTreatmentMessage, resetDeleteTreatmentMessage, resetSearchTreatmentMessage } = treatmentSlice.actions;

export default treatmentSlice.reducer;